import React from "react";
import styled from "styled-components";

const ProgressBarContainer = styled.div`
    flex: 1 1 auto;
    min-width: 0;
    height: 10px;
    margin-top: 1px;
    background-color: #EEF2F9;
    border-radius: 8px;
    overflow: hidden;
`;

const ProgressBarFiller = styled.div`
    width: ${props => props.width}%;
    height: 100%;
    background-color: ${props => props.color || "#007bff"};
    border-radius: 8px;
`;

const ProgressBar = ({ value, moodType }) => {
    const moodColors = {
        Happy: "#654CB8",
        Content: "#4C86B8",
        Neutral: "#4CB8B8",
        Sad: "#4CB858",
        Unhappy: "#C3CE45",
        Tired: "#FF981F",
        Stressed: "#D94B4B",
        Sick: "#B7D3A8",
    };

    // Get the color based on the moodType, or use the default color
    const color = moodColors[moodType] || "#007bff";
    const width = Math.max(0, Math.min(100, value));


    return (
        <ProgressBarContainer>
            <ProgressBarFiller width={width} color={color} />
        </ProgressBarContainer>
    );
};

export default ProgressBar;
